import React from 'react';
import ParagraphEditor from "./widgets/ParagraphEditor.js";
export default {
  matches: {
    use: 'MenuBar',
    client: 'CustomTextModelEditor'
  },
  id: 'Rich.Text.Editor.Paragraph',
  layout: {
    sort: 'F'
  },
  handles: () => true,
  customComponent: props => {
    const {
      context: {
        editor
      }
    } = props;
    return /*#__PURE__*/React.createElement(ParagraphEditor, {
      ...props,
      active: editor.isActive('orderedList') || editor.isActive('unorderedList') || editor.isActive('orderedList') || editor.isActive('heading')
    });
  }
};